export default (value: number) => {
    switch (true) {
        case value < 120: return 'Under 2 hours';
        case value < 240: return '4 hours';
        case value < 360: return '6 hours';
        case value < 480: return '8 hours';
        default:
            var durationInDays = ((value / 60) / 8);
            var durationDecimals = durationInDays - Math.floor(durationInDays);
            if (durationDecimals >= 0.01 && durationDecimals <= 0.5) {
                return `${Math.floor(durationInDays) + 0.5} days`;
            } else {
                return `${Math.ceil(durationInDays)} days`;
            }
    }
};